import { Injectable, OnDestroy } from '@angular/core';
import { CookieService, EnvironmentService } from '@core/feature';
import { AuthStorageService, OCC_USER_ID_ANONYMOUS, UserIdService } from '@spartacus/core';
import { Subscription, iif, of } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';

/**
 * Устанавливает информацию о пользователе (анонимный или авторизованный) в куки.
 *
 * Устанавливается только на клиенте, так как тогда есть информация о авторизации пользователя.
 */
@Injectable({ providedIn: 'root' })
export class UserAuthCookieDumpService implements OnDestroy {
  protected subscription = new Subscription();

  constructor(
    private environmentService: EnvironmentService,
    private userIDService: UserIdService,
    private cookieService: CookieService,
    private authStorageService: AuthStorageService,
  ) {}

  sync(): void {
    if (this.environmentService.isPlatformBrowser) {
      this.subscription.add(
        this.userIDService
          .getUserId()
          .pipe(
            distinctUntilChanged(),
            switchMap((userId: string) =>
              iif(
                () => userId === OCC_USER_ID_ANONYMOUS,
                of(
                  ((): Date => {
                    const date = new Date();
                    date.setDate(date.getDate() + 1);

                    return date;
                  })(),
                ),
                this.authStorageService.getToken().pipe(
                  filter((token) => Boolean(token && (token.refresh_token || token.expires_at))),
                  map(
                    (token) =>
                      (token.refresh_token && +JSON.parse(atob(token.refresh_token.split('.')[1]))['exp'] * 1000) ||
                      +token.expires_at,
                  ),
                  map((expires) => new Date(expires)),
                ),
              ).pipe(map((date) => ({ userId, date }))),
            ),
          )
          .subscribe(({ userId, date }) => {
            this.cookieService.put('auth_user_id', userId, {
              path: '/',
              expires: date,
            });
          }),
      );
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
